/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b30a76b80c6ee3bf05427473bba7b309>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ArrowUpCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/arrow-up-circle
 * Usage guidance:
 * Known uses: upgrading to a paid plan
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ArrowUpCircleIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "ArrowUpCircleIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M7.526 4.168a.75.75 0 0 1 1.004.052l3.5 3.5-1.06 1.06-2.22-2.22v5.94h-1.5V6.56L5.03 8.78 3.97 7.72l3.5-3.5z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var _default = exports.default = ArrowUpCircleIcon;